import {
  checkIsBankOffer,
  checkIsCardOffer,
  checkIsNoneOffer,
  checkIsUnipalOffer,
  getOfferTitle,
} from '@/components/offers/helpers';
import { useVerifiedOffer, useVerifiedOfferBin } from '@/logic/state/offers';

import { OfferModel } from '@/services/offers';
import shallow from 'zustand/shallow';

export function useOfferHandler(offer: OfferModel) {
  const [verifiedOffer, setVerifiedOffer] = useVerifiedOffer(
    s => [s.verifiedOffer, s.setVerifiedOffer],
    shallow
  );
  const [setVerifiedOfferBin, setVerifiedOfferLast4Bin] = useVerifiedOfferBin(
    s => [s.setVerifiedOfferBin, s.setVerifiedOfferLast4Bin],
    shallow
  );

  const isBankOffer = checkIsBankOffer(offer);
  const isUnipalOffer = checkIsUnipalOffer(offer);
  const isNoneOffer = checkIsNoneOffer(offer);
  const isCardOffer = checkIsCardOffer(offer);
  const isBankOfferApplied = verifiedOffer?.isBankOfferApplied;

  const isOfferVerified = verifiedOffer?.id && verifiedOffer?.id === offer?.id;

  const handleDeleteOffer = () => {
    setVerifiedOffer(null);
    setVerifiedOfferBin(null);
    setVerifiedOfferLast4Bin(null);
  };

  const offerTitle = getOfferTitle(offer);

  return {
    isBankOffer,
    isBankOfferApplied,
    isOfferVerified,
    offerTitle,
    offerName: isBankOffer || isCardOffer ? offer?.bankName : offer?.title,
    offerHint: isBankOffer || isCardOffer ? offer?.title : offer?.hint,
    handleDeleteOffer,
    isUnipalOffer,
    isNoneOffer,
    isCardOffer,
  };
}
